import React, { useEffect, useRef, useState } from "react";

const ProductwisePortfolio = (props) => {
  const infoForm = useRef(null);
  const [productInfoData, setProductInfoData] = useState({});
  const [timeline, setTimeline] = useState("TODAY");
  const revenueInfoCardData = [
    {
      title: "Personal Loan",
      count: productInfoData?.personalLoan?.count || 0,
      amount: productInfoData?.personalLoan?.amount || 0,
      icon: imagepaths.moneyBagIcon,
    },
    {
      title: "Business Loan",
      count: productInfoData?.businessLoan?.count || 0,
      amount: productInfoData?.businessLoan?.amount || 0,
      icon: imagepaths.suitcaseIcon,
    },
    {
      title: "Home Loan / LAP",
      count: productInfoData?.homeLoan?.count || 0,
      amount: productInfoData?.homeLoan?.amount || 0,
      icon: imagepaths.homeSecureIcon,
    },
    {
      title: "Gold Loan",
      count: productInfoData?.goldLoan?.count || 0,
      amount: productInfoData?.goldLoan?.amount || 0,
      icon: imagepaths.goldBarIcon,
    },
    {
      title: "Insurance Loan",
      count: productInfoData?.insuranceLoan?.count || 0,
      amount: productInfoData?.insuranceLoan?.amount || 0,
      icon: imagepaths.guardCheckIcon,
    },
    {
      title: "Credit Card Loans",
      count: productInfoData?.creditCardLoan?.count || 0,
      amount: productInfoData?.creditCardLoan?.amount || 0,
      icon: imagepaths.creditcardsIcon,
    },
    {
      title: "Education Loan",
      count: productInfoData?.educationLoan?.count || 0,
      amount: productInfoData?.educationLoan?.amount || 0,
      icon: imagepaths.gradCapIcon,
    },
    {
      title: "Corporate Loan",
      count: productInfoData?.corporateLoan?.count || 0,
      amount: productInfoData?.corporateLoan?.amount || 0,
      icon: imagepaths.buildingIcon,
    },
  ];

  // REVENUE INFO

  const getProductMetrics = (query, params) => {
    let data = {
      ...query,
    };

    let payload = {};
    if (params) {
      payload = {
        timeline: params,
      };
    } else {
      payload = {
        timeline: timeline,
      };
    }
    props.apis.apiGetProductMetrics(data, payload).then((res) => {
      console.log({ res });
      let resmap = {
        personalLoan: filterResponse(res, "PERSONAL LOAN"),
        businessLoan: filterResponse(res, "BUSINESS LOAN"),
        homeLoan: filterResponse(res, "HOME LOAN"),
        goldLoan: filterResponse(res, "GOLD LOAN"),
        insuranceLoan: filterResponse(res, "INSURANCE LOAN"),
        creditCardLoan: filterResponse(res, "CREDIT CARD LOAN"),
        educationLoan: filterResponse(res, "EDUCATION LOAN"),
        corporateLoan: filterResponse(res, "CORPORATE LOAN"),
      };
      setProductInfoData(resmap);
    });
  };

  const filterResponse = (response, field) => {
    return (
      response?.totalProductDist?.filter((v) => v?.productType === field)[0] ||
      {}
    );
  };

  const showInputs = (inputnames) => {
    if (inputnames.length > 0) {
      inputnames.forEach((id) => {
        const element = document.getElementById(id);
        if (element) {
          element.classList.remove("d-none");
        }
      });
    }
  };

  const hideInputs = (inputnames) => {
    if (inputnames.length > 0) {
      inputnames.forEach((id) => {
        const element = document.getElementById(id);
        if (element) {
          element.classList.add("d-none");
        }
      });
    }
  };

  const handleDateChange = (value) => {
    let val = value[0]?.key || "TODAY";
    let inputs = [
      "productinfo-column-start_date",
      "productinfo-column-end_date",
      "productinfo-column-search_btn",
      "productinfo-column-reset_btn",
    ];
    // console.log({ val });
    if (val === "CUSTOM") {
      showInputs(inputs);
      setProductInfoData({});
    } else {
      hideInputs(inputs);
      setTimeline(val);
    }
  };

  const onSearch = () => {
    let data = infoForm.current.form.current.getData();
    let queryData = {
      start_date: new Date(data?.start_date).toISOString(),
      end_date: new Date(data?.end_date).toISOString(),
    };
    getProductMetrics(queryData, "CUSTOM");
  };

  const resetSearchForm = () => {
    infoForm?.current?.form?.current?.reset();
    let inputs = [
      "productinfo-column-start_date",
      "productinfo-column-end_date",
      "productinfo-column-search_btn",
      "productinfo-column-reset_btn",
    ];
    hideInputs(inputs);
    getProductMetrics({}, "TODAY");
  };

  useEffect(() => {
    getProductMetrics();
  }, [timeline]);

  props.$setNode({
    props,
    productInfoData,
  });
  return (
    <>
      <div className="mb-4 dashboard_form_box">
        <div className="d-flex flex-wrap justify-content-between">
          <h2 className="fs-4 mt-2">Product Wise Portfolio</h2>
          <div className="form_outer w-100 mw-200">
            <AppForm
              ref={infoForm}
              onSubmit={(...args) => onSearch(...args)}
              className="row justify-content-end"
            >
              <div className="col-12" id="column-timeline">
                <AppInputFocus
                  type="select"
                  name="timeline"
                  label="Time Line"
                  options={_enum.OVERALL_DETAIL}
                  onChange={(...args) => handleDateChange(...args)}
                  defaultValue={"TODAY"}
                  placeholder="Time Line"
                ></AppInputFocus>
              </div>
              <div
                className="col-12 col-md-3 col-lg-3 col-xl-2 d-none"
                id="productinfo-column-start_date"
              >
                <AppInputFocus
                  type="date"
                  name="start_date"
                  label="Start Date"
                  placeholder="Start Date"
                  required={true}
                ></AppInputFocus>
              </div>
              <div
                className="col-12 col-md-3 col-lg-3 col-xl-2 d-none"
                id="productinfo-column-end_date"
              >
                <AppInputFocus
                  type="date"
                  name="end_date"
                  label="End Date"
                  placeholder="End Date"
                  required={true}
                ></AppInputFocus>
              </div>
              <div
                className="col-2 col-md-1 col-lg-1 col-xl-1 d-none"
                id="productinfo-column-search_btn"
              >
                <button type="submit" className="btn btn-primary search_btn">
                  <i className="fa fa-search"></i>
                  <span>Search</span>
                </button>
              </div>
              <div
                className="col-2 col-md-1 col-lg-1 col-xl-1 d-none"
                id="productinfo-column-reset_btn"
              >
                <button
                  type="button"
                  className="btn btn-primary search_btn"
                  onClick={(...args) => resetSearchForm(...args)}
                >
                  <i class="fa-solid fa-filter-circle-xmark"></i>
                  <span>Reset</span>
                </button>
              </div>
            </AppForm>
          </div>
        </div>
        <div className="row pt-0">
          {revenueInfoCardData &&
            revenueInfoCardData.map((revenue) => {
              return (
                <>
                  <div className="col-xl-3 col-sm-6">
                    <div className="card dashboard_card application_card revenue_info_card">
                      <div className="card-body">
                        <div className="content">
                          <p className="card_label">{revenue?.title}</p>
                          <p className="count">{revenue?.amount?.curLakhs()}</p>
                          <p>
                            Count :
                            <span className="primary-red ms-1">
                              {revenue?.count}
                            </span>
                          </p>
                        </div>
                        <div className="icon_container">
                          {/* <div className="icon">
                            <img src={revenue?.icon} alt="icon image" />
                          </div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              );
            })}
        </div>
      </div>
    </>
  );
};

export default constore(ProductwisePortfolio);
